import { Injectable } from "@angular/core";
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router
} from "@angular/router";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private auth: AuthService, private router: Router) {}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> {
		return this.auth.checkState().switchMap(data => {
			if (data) {
				return Observable.of(true);
			} else {
				this.router.navigate(["/"]);
				return Observable.of(false);
			}
		});
	}
}



// WEBPACK FOOTER //
// F:/Projects/anoki/src/app/core/auth.guard.ts